import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setActiveVehicle } from '../../Redux/slices/vehicleState'
import ScrollToTargetAdjusted from '../../Utils/ScrollToTargetAdjusted'
import AddVehicle from './AddVehicle'
import UpdateVehicle from './UpdateVehicle'
import ViewVehicles from './ViewVehicles'

export default function ManageVehicles () {
  const [editVehicle,setEditVehicle] = useState({docid:false})
  const dispatch = useDispatch()
  function setEditHandler(form){
    
    return ()=>{
      ScrollToTargetAdjusted("updateVehicleForm")
      dispatch(setActiveVehicle(null))
      setEditVehicle(form)
    }
  }
  return (
    <div className='w-full flex flex-col'>
        <AddVehicle/>
        <h1 className='ml-8 text-4xl font-medium'>Vehicles</h1>
        <ViewVehicles setEditHandler={setEditHandler}/>
        {editVehicle.docid&&<UpdateVehicle formData={editVehicle} setFormData={setEditVehicle}/>}
    </div>
  )
}
